<!-- Component for Masonry+PhotoSwipe gallery -->
<template>
    <div class="gallery">
        <masonry :cols="{default: 4, 1023: 3, 767: 2}" :gutter="{default: '0'}"
          >
            <figure v-for="(image, index) in imageList" :key="index" class="gallery__figure">
                <span class="mask"></span>
                <img :src="image.thumbnail" @click="showPhotoSwipe(index)" alt="" class="gallery__img">
            </figure>
        </masonry>

        <PhotoSwipe :isOpen="isOpen" :items="imageList" :options="options" @close="hidePhotoSwipe" />
    </div>
</template>

<script>
import { PhotoSwipe } from 'v-photoswipe';

//import icons
import '@/compiled-icons/plus';

export default {
    components: {
        PhotoSwipe
    },

    data () {
        return {
            isOpen: false,
            isOpenGallery: false,
            options: {
                index: 0
            },
            optionsGallery: {},
            imageList: [
                {
                    src: 'https://picsum.photos/1200/900?image=1031',
                    thumbnail: 'https://picsum.photos/640/360?image=1031',
                    w: 1200,
                    h: 900,
                    title: 'This is dummy caption.'
                }, 
                {
                    src: 'https://picsum.photos/900/1200?image=1033',
                    thumbnail: 'https://picsum.photos/360/600?image=1033',
                    w: 900,
                    h: 1200,
                    title: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'
                },
                {
                    src: 'https://picsum.photos/1200/900?image=1072',
                    thumbnail: 'https://picsum.photos/320/180?image=1072',
                    w: 1200,
                    h: 900,
                    title: 'This is dummy caption.'
                },
                {
                    src: 'https://picsum.photos/1200/900?image=1048',
                    thumbnail: 'https://picsum.photos/320/180?image=1048',
                    w: 1200,
                    h: 900,
                    title: 'Optio dicta ipsum fugiat enim, veritatis eos ab ut totam id, sit maiores, quis nam consequuntur incidunt in ipsam vitae maxime corporis.'
                },
                {
                    src: 'https://picsum.photos/900/1200?image=1059',
                    thumbnail: 'https://picsum.photos/180/300?image=1059',
                    w: 900,
                    h: 1200,
                    title: 'This is dummy caption. It has been placed here solely to demonstrate the look and feel of finished, typeset text.'
                },
                {
                    src: 'https://picsum.photos/1200/900?image=1065',
                    thumbnail: 'https://picsum.photos/320/180?image=1065',
                    w: 1200,
                    h: 900,
                    title: 'This is dummy caption.'
                },
                {
                    src: 'https://picsum.photos/900/1200?image=1081',
                    thumbnail: 'https://picsum.photos/180/300?image=1081',
                    w: 900,
                    h: 1200,
                    title: 'This is dummy caption. It has been placed here solely to demonstrate the look and feel of finished, typeset text.'
                },
                {
                    src: 'https://picsum.photos/900/1200?image=299',
                    thumbnail: 'https://picsum.photos/180/300?image=299',
                    w: 900,
                    h: 1200,
                    title: 'This is dummy caption. It has been placed here solely to demonstrate the look and feel of finished, typeset text.'
                },
            ]
        }
    },
    methods: {
        showPhotoSwipe (index) {
            this.isOpen = true
            this.$set(this.options, 'index', index)
        },
        hidePhotoSwipe () {
            this.isOpen = false
        },
        getImages() {
          fetch('https://next.json-generator.com/api/json/get/NyL0M8ZGD')
            .then(response => response.json())
            .then(data => (this.imageList = data));
        }
    },

    created: function() {
        // this.getImages();
    }
};
</script>

<style scoped lang="scss">
    @import "@/scss/modules/_gallery.scss";
</style>